<template>
  <div
    :class="$style.custom_columns_list"
    :style="showStub ? {padding: 0} : ''"
  >
    <div
      v-if="showStub"
      :class="$style.stub"
    >
      <div :class="$style.wrapper">
        <vgp-svg-image name="columns-bar-empty-1" />
        <div
          :class="$style.desc"
          v-html="stubDescription"
        />
      </div>
    </div>
    <div
      v-else
      ref="columnsList"
      :class="[$style.list, 'gantt_scroll']"
    >
      <div
        v-for="(item, index) in columns"
        :key="index"
        :data-id="item.columnId"
      >
        <div :class="$style.row">
          <div :class="$style.row__icon">
            <svg-sprite
              :name="item.icon.name"
              :type="item.icon.type"
              :size="item.icon.size"
            />
          </div>
          <div :class="$style.row__name">
            {{ item.value }}
          </div>
          <div :class="$style.row__right">
            <div
              v-if="isEditable && !isArchived"
              :class="$style.buttons"
            >
              <div
                v-if="customColumnsEditAccess"
                :class="$style.buttons__edit"
              >
                <icon-button
                  id="gp_autotest_columns_bar_edit"
                  :icon="{ name:'pensil', size: 20 }"
                  size="small"
                  @onClick="onEditClick(item)"
                />
              </div>
              <div
                v-if="customColumnsRemoveAccess"
                :class="$style.buttons__delete"
              >
                <icon-button
                  id="gp_autotest_columns_bar_delete"
                  :icon="{ name:'delete', size: 20 }"
                  size="small"
                  @onClick="onDeleteClick(item)"
                />
              </div>
            </div>
            <tooltip
              v-if="item.tooltip"
              :position="'top'"
              :content="item.tooltip"
              :class="$style.tooltip"
              :full-width="true"
            >
              <template #body>
                <svg-sprite :name="'info'" />
              </template>
            </tooltip>
            <div :class="$style.checkbox">
              <vgp-checkbox
                :size="16"
                :checked="item.enabled"
                @update:checked="onChange($event, item)"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      v-if="showFooter"
      :class="$style.footer"
    >
      <upgrade-button
        v-if="showPricingUpgradeButton"
        :feature="'custom_fields'"
      />
      <!-- <vgp-button
        v-else-if="showManageButton"
        id="gp_autotest_columns_bar_redirect_to_account_settings"
        :label="locale('columns_bar_manage_global_columns')"
        type="text"
        :icon="{name: 'arrow-right', type: 'bold', size: 20}"
        icon-side="right"
        @onClick="$emit('redirectToSettings')"
      /> -->
      <div v-else-if="showAssignButtons">
        <div
          v-if="createCustomColumnsAccess"
          :style="allColumns.length ? {marginBottom: '12px'} : {}"
        >
          <vgp-button
            id="gp_autotest_columns_bar_add_new_column"
            :class="$style.button"
            :label="locale('columns_bar_add_new_column')"
            :type="'primary-border'"
            :icon="{name: 'plus-1', type:'bold', size: 24}"
            :icon-side="'left'"
            @onClick="onCreateNewColumnClick"
          />
        </div>
        <vgp-button
          v-if="allColumns.length"
          id="gp_autotest_columns_bar_use_existed"
          :class="$style.button"
          :label="locale('columns_bar_use_existed')"
          :type="'primary-border'"
          :icon="{name: 'change', type:'bold', size: 24}"
          :icon-side="'left'"
          @onClick="onUseExistedColumnClick"
        />
      </div>
    </div>
  </div>
</template>

<script>
import vgpCheckbox from '../../../common/VueComponents/checkbox/vgpCheckbox.vue';
import iconButton from '../../../common/VueComponents/globalButton/withIcon/iconButton.vue';
import vgpSvgImage from '../../../common/VueComponents/VueIcon/vgpSvgImage.vue';
import svgSprite from '../../../common/VueComponents/VueIcon/svgSprite.vue';
import Tooltip from '../../../common/VueComponents/tooltips/tooltip.vue';
import pricingHelper from '../../../../helpers/pricingHelper';
import upgradeButton from '../../../common/VueComponents/ugradeButton/upgradeButton.vue';
import projectsModel from '$$projectModel';
import rights from '../../../../components/rights/index';
import plansModel from '../../../../models/plans';

export default {
  name: 'ColumnsBarCustomColumnsTab',
  components: {
    vgpSvgImage,
    vgpCheckbox,
    iconButton,
    svgSprite,
    Tooltip,
    upgradeButton,
  },
  props: {
    columns: { type: Array, required: true, default: () => [] },
    isEditable: { type: Boolean, required: true, default: true },
    focusedColumnId: { type: [Number, String], required: false, default: null },
    isArchived: { type: Boolean, required: true, default: true },
  },
  emits: {
    onCreateNewColumnClick: null,
    onUseExistedColumnClick: null,
    openEditBar: Object,
    onDeleteClick: Object,
    changeCheckbox: Object,
    redirectToSettings: null,
  },
  data() {
    return {
      locale: __,
    };
  },
  computed: {
    allColumns() {
      return this.$store.getters['columns/getAllCustomColumns'];
    },
    customColumnsPricingAccess() {
      return pricingHelper.checkPricingAccess('custom_fields');
    },
    customColumnsEditAccess() {
      return rights.account.hasRight('custom_fields_edit');
    },
    customColumnsRemoveAccess() {
      return rights.project.hasRight(projectsModel.getActiveGanttId(), 'custom_fields_unassing_from_project');
    },
    customColumnsAssignAccess() {
      return rights.project.hasRight(projectsModel.getActiveGanttId(), 'custom_fields_assing_to_project');
    },
    customColumnsAccountAccess() {
      return rights.account.hasRight('custom_fields_settings');
    },
    createCustomColumnsAccess() {
      return rights.account.hasRight('custom_fields_create');
    },
    // showManageButton() {
    //   if (['projectsMultiView', 'listView'].includes(this.$route.name) && !this.columns.length && this.customColumnsAccountAccess) {
    //     return true;
    //   }

    //   return false;
    // },
    showAssignButtons() {
      return this.isEditable && this.customColumnsAssignAccess;
    },
    showPricingUpgradeButton() {
      return this.isOwner && !this.customColumnsPricingAccess;
    },
    showFooter() {
      if (this.isArchived) {
        return false;
      }

      if (!this.isOwner && !this.customColumnsPricingAccess) {
        return false;
      }

      if (this.showPricingUpgradeButton) {
        return true;
      }

      // if (this.showManageButton) {
      //   return true;
      // }

      if (this.showAssignButtons) {
        return true;
      }

      return false;
    },
    showStub() {
      return !this.customColumnsPricingAccess || !this.columns.length;
    },
    stubDescription() {
      if (!this.customColumnsPricingAccess) {
        const pro = plansModel.getPlanInfoById(15);
        const business = plansModel.getPlanInfoById(16);
        const enterprise = plansModel.getPlanInfoById(18);

        const pro_plan_name = pro?.plan_name[0].toUpperCase() + pro?.plan_name.slice(1);
        const business_plan_name = business?.plan_name[0].toUpperCase() + business?.plan_name.slice(1);
        const enterprise_plan_name = enterprise?.plan_name[0].toUpperCase() + enterprise?.plan_name.slice(1);

        return __('columns_bar_stub_desc_pricing_with_plan_names', { pro: pro_plan_name, business: business_plan_name, enterprise: enterprise_plan_name });
      }

      return __('columns_bar_stub_desc_create_or_use_field');
    },
    isOwner() {
      return rights.account.isOwner();
    },
  },
  watch: {
    focusedColumnId: {
      handler(id) {
        if (id) {
          setTimeout(() => {
            this.scrollToElementById(id);
          }, 0);
        }
      },
      immediate: true,
    },
  },
  methods: {
    onEditClick(column) {
      this.$emit('openEditBar', column);
    },
    onDeleteClick(column) {
      this.$emit('onDeleteClick', column);
    },
    onChange(e, column) {
      this.$emit('changeCheckbox', {
        id: column.id,
        value: !column.enabled,
        custom: column.custom || null,
      });
    },
    onCreateNewColumnClick() {
      userExtAnalytics.log('columns_sidebar_create_new_column_click');
      this.$emit('onCreateNewColumnClick');
    },
    onUseExistedColumnClick() {
      userExtAnalytics.log('columns_sidebar_use_existed_columns_click');
      this.$emit('onUseExistedColumnClick');
    },
    scrollToElementById(id) {
      const list = this.$refs.columnsList;

      if (list) {
        const target = list.querySelector(`[data-id="${id}"]`);

        if (target) {
          target.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
        }
      }
    },
  },
};
</script>

<style module src='./customColumnsTab.less' lang='less'></style>
